<template>
  <div class="container">
    <div class="header">
      <div class="desh"></div>
      <p class="title">{{title}}</p>
    </div>

    <div class="nav-list">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        background-color="#1D3994"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <template  v-for="item in list">
          <el-menu-item
            v-if="!item.children.length"
            :key="item.id"
            :index="item.id + ''"
            @click="navClick(item)"
           style="color: white"
          >
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
          <el-submenu
            v-if="item.children.length"
            :key="item.id"
            :index="item.id + ''">
            <span slot="title">{{item.name}}</span>
            <template v-for="children in item.children">
              <el-menu-item
                v-if="!children.children.length"
                :key="children.id"
                :index="children.id + ''"
                style="color: white;padding-left: 20px;"
                @click="navClick(children)">
                <span slot="title">{{children.name}}</span>
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { orgId, requestUrl } from '../common/cons'
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'NewsNav',
  props: {
    isList: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      id: '',
      title: '',
      list: [],
      activeIndex: '1'
    }
  },
  async mounted () {
    this.id = this.$route.params.id
    await this.init()
  },
  computed: {
    ...mapGetters({
      mainColumn: 'getMainColumn'
    })
  },
  watch: {
    mainColumn: function (columnId) {
      this.id = columnId
      this.init()
    }
  },
  methods: {
    ...mapMutations([
      'updateCurrentColumnId',
      'updateMainColumnId',
      'updateArticleId'
    ]),
    async init () {
      if (this.isList === true) {
        const nav = await axios.get(`${requestUrl}/news/getChannelList?id=${this.id}`)
        this.title = nav.data[0].name
        this.list = nav.data[0].children
        if (this.id === nav.data[0].children[0].id + '') {
          this.activeIndex = nav.data[0].children[0].id + ''
        } else {
          this.activeIndex = this.$route.params.id
        }
      } else {
        this.id = this.$route.params.id
        const nav = await axios.get(`${requestUrl}/news/getArticleMenu/${this.id}`)
        this.title = nav.data.menu[0].name
        this.list = nav.data.menu[0].children
        this.activeIndex = nav.data.article.article.column_id + ''
      }
    },
    async navClick (column) {
      if (column.type === 'channel') {
        if (this.isList === true) {
          this.$router.push({
            path: `/news/${column.id}`
          })
          this.updateCurrentColumnId(column.id)
        } else {
          this.$router.push({
            path: `/news/${column.id}`
          })
          this.updateCurrentColumnId(column.id)
        }
      } else {
        const result = await axios.get(`${requestUrl}/news/article?id=${column.id}&orgId=${orgId}`)
        const articleId = result.data[0].id
        if (this.isList === true) {
          this.$router.push({
            path: `/content/${articleId}`
          })
        }
        this.updateArticleId(articleId)
        this.updateCurrentColumnId(column.id)
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 220px;
}

.header {
  width: 100%;
  height: 90px;
  background-color: rgb(216,17,50);
  box-sizing: border-box;
  padding-top: 20px;
}

.desh {
  width: 20px;
  height: 6px;
  background-color: #fff;
  margin-left: 20px;
}

.header .title {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  margin-left: 20px;
}

.nav-list {
  width: 220px;
  margin-top: 2px;
}
.nav-list .el-menu-vertical-demo >>> .el-menu-item {
  color: white;
}
.nav-list >>> .el-menu-item{
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsNav.vue